import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import DatePicker from 'vue2-datepicker'
import {
  Validator
} from 'vee-validate'
import moment from 'moment'

export default {
  name: 'local-trip',
  components: {
    VueElementLoading,
    Paginate,
    DatePicker
  },
  props: [],
  data() {
    return {
      fromDate: '',
      toDate: '',
      hubid: '',
      LocalTripList: [],
      isLoading: false,
      pageCount: 0,
      pageNo: 0,
      createdBy: '',
      tripstate: '',
      totalcount: 0,
      IsError: false,
      vehicleno: '',
      modalShow: false,
      schedulemasteridarrr: [],
      connectionnamearrr: [],
      checkarray: [],
      tripId: '',
      token: '',
      invalidTokenModal: false,
      invalidtokenmsg: ''
    }
  },
  computed: {},
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.hubid = userdetail[0].HubId;
    this.createdBy = userdetail[0].email;
    this.pageNo = 0;
  },
  methods: {
    bmodalopen(a, b, c) {
      this.tripId = a
      this.schedulemasteridarrr = b
      this.connectionnamearrr = c
      this.checkarray = []
      for (var j = 0; j < this.schedulemasteridarrr.length; j++) {
        this.checkarray.push({
          "schedulemasterid": this.schedulemasteridarrr[j],
          "connectionname": this.connectionnamearrr[j]
        })
      }
      this.modalShow = true;
    },
    bmodalclose() {
      this.tripId = '';
      this.checkarray = [];
      this.modalShow = false;
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        } else {
          this.getTripDetails();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    getTripDetails(IsSearch) {
      var LocalTripList = []
      this.LocalTripList = []
      this.isLoading = true
      var fromdate= moment(this.fromDate).format('YYYY-MM-DD')
      var todate = moment(this.toDate).format('YYYY-MM-DD')
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getLocalTripVehiclesListByHubId?HubID=' + this.hubid[0] + '&TripState=' + this.tripstate + '&VehicleNo=' + this.vehicleno + '&fromDate=' + fromdate + '&toDate=' + todate + '&offset=' + this.pageNo + '&limit=10',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoading = false
          var demo = []
          if (result.data.ResultCode == 100) {
            var finalresult = []
            this.$alertify.success(result.data.ReturnMessage)

            for (var i = 0; i < result.data.ResultData.length; i++) {
              var schedulemasteridarr = []
              var connectionnamearr = []
              if (result.data.ResultData[i].connections) {
                for (var j = 0; j < result.data.ResultData[i].connections.length; j++) {
                  schedulemasteridarr.push(result.data.ResultData[i].connections[j].schedulemasterid)
                  connectionnamearr.push(result.data.ResultData[i].connections[j].connectionname)
                }
                finalresult[i] = {
                  "hubid": result.data.ResultData[i].hubid,
                  "connectionid": result.data.ResultData[i].connectionid,
                  "vehicleno": result.data.ResultData[i].vehicleno,
                  "tripstate": result.data.ResultData[i].tripstate,
                  "datetime": result.data.ResultData[i].datetime,
                  "tripid": result.data.ResultData[i].tripid,
                  "openkm": result.data.ResultData[i].openkm,
                  "closekm": result.data.ResultData[i].closekm,
                  "connections": result.data.ResultData[i].connections,
                  "schedulemasteridarr": schedulemasteridarr,
                  "connectionnamearr": connectionnamearr
                }
              } else {
                finalresult[i] = {
                  "hubid": result.data.ResultData[i].hubid,
                  "connectionid": result.data.ResultData[i].connectionid,
                  "vehicleno": result.data.ResultData[i].vehicleno,
                  "tripstate": result.data.ResultData[i].tripstate,
                  "datetime": result.data.ResultData[i].datetime,
                  "tripid": result.data.ResultData[i].tripid,
                  "openkm": result.data.ResultData[i].openkm,
                  "closekm": result.data.ResultData[i].closekm,
                  "connections": result.data.ResultData[i].connections,
                  "schedulemasteridarr": [result.data.ResultData[i].schedulemasterid],
                  "connectionnamearr": [result.data.ResultData[i].connectionname]
                }
              }
            }
            this.LocalTripList = finalresult
            this.totalcount = result.data.TotalCount
            let totalRows = result.data.TotalCount
            if (totalRows < 10) {
              this.pageCount = 1
            } else {
              this.pageCount = Math.ceil(totalRows / 10);
            }
          } else if (result.data.ResultCode == 101) {
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoading = false
          console.error(error)
        })
    },

    checkCloseKM(data, index) {
      var regex = /^[0-9]*$/
      if (data.closekms == '' || data.closekms == null) {
        this.IsError = true
        data.closekmsError = 'Enter Close KM'
      } else if (regex.test(data.closekms) == false) {
        this.IsError = true
        data.closekmsError = 'Invalid Value'
      } else if (data.closekms <= data.openkm) {
        this.IsError = true
        data.closekmsError = 'Close KM should be greater than Open KM'
      } else {
        this.IsError = false
        data.closekmsError = ''
      }
    },
    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    closeTrip(data, index) {
      if (data.closekms == '' || data.closekms == null) {
        this.IsError = true
        data.closekmsError = 'Enter Close KM'
        return false;
      } else if (data.closekms < data.openkm) {
        this.IsError = true
        data.closekmsError = 'Close KM should be greater that Open KM'
        return false;
      } else {
        this.IsError = false
        data.closekmsError = ''
      }
      this.input = ({
        "tripId": data.tripid,
        "closeKms": data.closekms,
        "lastmodifiedby": this.createdBy
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'closeLocalTrip',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.$alertify.success(result.data.ReturnMessage)
            this.getTripDetails();
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1) * 10;
      this.getTripDetails();
    },
    selectedTripState() {
      this.resetflt(1);
    },
    resetflt(IsSearch) {
      if (IsSearch !== 1) {
        this.tripstate = ''
      }
      this.tripId = '';
      this.checkarray = [];
      this.modalShow = false;
      this.LocalTripList = [],
        this.isLoading = false,
        this.totalcount = 0,
        this.IsError = false,
        this.vehicleno = '',
        this.fromDate = '',
        this.toDate = '',
        this.$validator.reset();
    },

  }
}



// WEBPACK FOOTER //
// ./src/views/components/TripManagement/LocalTrip/LocalTrip.js